// COOKIES
//
//
//
//
//
//
export function initMetaCookies() {

    const cookieRules = ['Analytics', 'Pipedrive', 'Vimeo']; // List of cookie rules
    const cookieStorage = localStorage;

    ////////////////////////////////
    // COOKIE INITIALIZATION
    ////////////////////////////////

    // Initialize cookies if not set
    if (!['superokay', 'okay'].includes(cookieStorage.getItem('cookie'))) {
        cookieStorage.setItem('cookie', 'newbie');
        cookieRules.forEach(rule => cookieStorage.setItem(`cookieRule${rule}`, 'off'));
        $(".cookiecorner").delay(500).addClass('cookiehello');
    }

    ////////////////////////////////
    // UPDATE VIMEO IFREMES
    ////////////////////////////////

    // Update Vimeo iframe visibility based on cookie rules
    function updateVimeoIframes() {
        const vimeoRule = cookieStorage.getItem('cookieRuleVimeo');
        $('.vimeo-wrapper iframe, .vimeo-wrapper-player iframe').each(function () {
            const originalSrc = $(this).data('src') || $(this).attr('src');
            $(this).data('src', originalSrc); // Ensure the original src is saved

            const $container = $(this).closest('.vimeo-wrapper');
            if (vimeoRule === 'on') {
                $(this).attr('src', originalSrc);
                $container.show();
            } else {
                $(this).removeAttr('src');
                $container.hide();
            }
        });
    }

    ////////////////////////////////
    // GENERAL COOKIE RULES HANDLING
    ////////////////////////////////

    // Set the status of a cookie rule
    function setRuleStatus(rule, status) {
        cookieStorage.setItem(`cookieRule${rule}`, status);
        $(`#cookieRule${rule}On`).toggleClass('antibutton', status !== 'on');
        $(`#cookieRule${rule}Off`).toggleClass('antibutton', status === 'on');

        if (rule === 'Vimeo') {
            $(".vimeoblocker").toggleClass('formblockerhidden', status === 'on');
            updateVimeoIframes();
        }
    }

    // Update all rules on page load
    function updateRules() {
        cookieRules.forEach(rule => {
            const status = cookieStorage.getItem(`cookieRule${rule}`);
            setRuleStatus(rule, status);
        });
    }

    ////////////////////////////////
    // COOKIE MODAL HANDLING
    ////////////////////////////////

    // Toggle the modal visibility
    function toggleModal(close = false) {
        $(".cookiecorner").toggleClass('cookiehello', !close);
        $('.cookiecorner-center, .cookiecorner-bottom').addClass('cookierulehello');
        updateRules();
    }

    // Show cookie consent modal (e.g., in footer settings)
    function cookiePop() {
        toggleModal();
    }

    // make available
    window.cookiePop = cookiePop;

    ////////////////////////////////
    // BUTTON CLICK HANDLERS
    ////////////////////////////////

    // Event listener for rule button clicks
    $(document).on('click', '[id^="cookieRule"]', function (e) {
        const [_, rule, action] = this.id.match(/cookieRule(\w+)(On|Off)/);
        setRuleStatus(rule, action.toLowerCase());
        e.preventDefault();
        location.reload(); // Reload after changing the rule
    });

    // General buttons for cookie consent
    $('#cookieSuperokay, #cookieBigSuperokay').click(function (e) {
        cookieStorage.setItem('cookie', 'superokay');
        cookieRules.forEach(rule => cookieStorage.setItem(`cookieRule${rule}`, 'on'));
        toggleModal(true);
        e.preventDefault();
        location.reload(); // Reload after consent
    });

    $('#cookieBigSettings').click(function (e) {
        cookieStorage.setItem('cookie', 'okay');
        toggleModal(true);
        e.preventDefault();
    });

    $('#cookieSettings').click(function (e) {
        $('.cookiecorner-center, .cookiecorner-bottom').toggleClass('cookierulehello');
        updateRules();
        e.preventDefault();
    });

    // Footer settings button
    $('#footersettings').click(function (e) {
        cookiePop();
        e.preventDefault();
    });

    // Vimeo blocker button
    $('.vimeoblockerBtn').click(function (e) {
        cookieStorage.setItem('cookieRuleVimeo', 'on');
        updateRules();
        e.preventDefault();
        location.reload(); // Reload after enabling Vimeo
    });

    ////////////////////////////////
    // INITIALIZATION
    ////////////////////////////////

    // Initialize the rules and Vimeo iframes
    updateRules();
    updateVimeoIframes();


    /////////////////////////////////////////////////
    // COOKIE SETTINGS BUTTON 
    /////////////////////////////////////////////////

    // Only add listener if cookie settings buttons exist
    if (document.querySelectorAll('.cookie-settings-button').length > 0) {
    document.addEventListener('click', function(event) {
        // Check if the clicked element has the cookie-settings-button class
        if (event.target.matches('.cookie-settings-button')) {
            cookiePop();
        }
    });
    }

    console.log('meta-cookies loaded');

} // end initMetaCookies